import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import MainLayoutRoutes from './components/common/layout/MainLayoutRoutes';
import './asset/style.scss';
import './App.css';
import Login from './components/login';
import { useDispatch, useSelector } from 'react-redux';
import { removeItem } from './components/utilities/utils';
import { RootState } from './store/reducers/state';
import ForgetPassword from './components/login/ForgetPassword';
import ConfirmForgetPassword from './components/login/ConfirmForgetPassword';
import ResetPassword from './components/login/ResetPassword';
import ConfirmResetPassword from './components/login/ConfirmResetPassword';
import MultiFactorAuthenticationSetup from './components/login/MultiFactorAuthenticationSetup';
import VerifyMfa from './components/login/VerifyMFA';
import AdminLogin from './components/login/AdminLogin';

const IDLE_DURATION_SECS = 3600;
const REDIRECT_URL = '/login';
const CHANNEL_NAME = 'activity_channel';

const App = () => {
  const navigate = useNavigate();

  const { isCallbackLink } = useSelector((state: RootState) => ({
    isCallbackLink: state.login.isCallbackLink,
  }));

  useEffect(() => {
    if (isCallbackLink) {
      removeItem('token');
      removeItem('role');
      navigate('/login', { state: { from: location.pathname } });
    }
  }, [isCallbackLink]);

  useEffect(() => {
    let idleTimeout: ReturnType<typeof setTimeout>;

    const channel = new BroadcastChannel(CHANNEL_NAME);

    const isLiveEvent = () =>
      window.location.pathname.includes('live-event') ||
      !!localStorage.getItem('IS_LIVE_EVENT');

    const logout = () => {
      if (!isLiveEvent()) {
        location.href = REDIRECT_URL;
      }
    };

    const resetIdleTimeout = () => {
      if (idleTimeout) clearTimeout(idleTimeout);
      idleTimeout = setTimeout(logout, IDLE_DURATION_SECS * 1000);
    };

    const handleLocalActivity = () => {
      resetIdleTimeout();
      channel.postMessage({ type: 'activity' });
    };


    channel.onmessage = (event) => {
      if (event.data?.type === 'activity') {
        resetIdleTimeout();
      }
    };

    const originalFetch = window.fetch;
    window.fetch = (...args: Parameters<typeof originalFetch>) => {
      handleLocalActivity();
      return originalFetch(...args);
    };

    // Start the timer on load
    resetIdleTimeout();

    // Listen for user events on this tab
    const events = ['click', 'touchstart', 'mousemove'] as const;
    events.forEach((evt) =>
      document.addEventListener(evt, handleLocalActivity, false)
    );

    return () => {
      clearTimeout(idleTimeout);
      events.forEach((evt) =>
        document.removeEventListener(evt, handleLocalActivity, false)
      );
      window.fetch = originalFetch;
      channel.close();
    };
  }, []);

  return (
    <div>
      <Routes>
        <Route path="/login?sa=:id" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/account/ForgetPassword" element={<ForgetPassword />} />
        <Route path="/platform-login" element={<AdminLogin />} />
        <Route path="/account/ConfirmForgetPassword" element={<ConfirmForgetPassword />} />
        <Route path="/account/ConfirmResetPassword" element={<ConfirmResetPassword />} />
        <Route path="/account/ResetPassword" element={<ResetPassword />} />
        <Route path="/account/MultiFactorAuthentication" element={<MultiFactorAuthenticationSetup />} />
        <Route path="/account/CodeVerification" element={<VerifyMfa />} />
        <Route path="*" element={<MainLayoutRoutes />} />
      </Routes>
    </div>
  );
};

export default App;